import { notification } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

export function openNotification({ message }) {
  notification.open({
    message: message,
    icon: <CheckOutlined style={{ color: '#108ee9' }} />,
  });
}
